(function(){
  var s=document.currentScript, W=s&&s.previousElementSibling;
  while(W&&!W.classList.contains('mirb')){W=W.previousElementSibling;}
  if(!W)W=document.querySelector('.mirb');
  if(!W||W.dataset.b)return; W.dataset.b=1;

  var cards=W.querySelectorAll('.mirb-card'), gifts=W.querySelectorAll('.mirb-gift');
  var CURRENT=null, TIER=1, BUSY=false, LETTHROUGH=false;

  var nativeSet=Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype,'value').set;
  function setVal(el,v){
    try{nativeSet.call(el,String(v));}catch(e){el.value=String(v);}
    el.setAttribute('value',String(v));
    el.dispatchEvent(new Event('input',{bubbles:true}));
    el.dispatchEvent(new Event('change',{bubbles:true}));
  }

  // Le bloc offre est rendu AVANT le bloc bouton d'achat : au premier appel le
  // formulaire n'existe pas encore. On resynchronise donc en boucle courte ET
  // juste avant l'ajout, sinon Horizon envoie la variante par defaut (1 frasco).
  function syncForms(id){
    if(id==null) return false;
    CURRENT=String(id);
    var found=false;
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function(f){
      var h=f.querySelector('input[name="id"]');
      if(!h){h=document.createElement('input');h.type='hidden';h.name='id';f.appendChild(h);}
      found=true;
      if(h.value!==CURRENT) setVal(h,CURRENT);
    });
    return found;
  }

  function hideNative(){
    var vals=[];cards.forEach(function(c){vals.push(c.querySelector('.mirb-dur').textContent.trim());});
    document.querySelectorAll('label').forEach(function(e){
      if(W.contains(e))return;
      var t=(e.textContent||'').replace(/\s+/g,' ').trim();
      vals.forEach(function(v){
        if(v&&t.indexOf(v)===0&&t.length<60){
          var n=e.closest('fieldset')||e.parentElement;
          if(n&&!n.querySelector('[type=submit],[name=add]')&&!n.contains(W))n.style.display='none';
        }
      });
    });
  }

  function pick(c){
    cards.forEach(function(x){x.classList.remove('on');});c.classList.add('on');
    TIER=+c.dataset.i;
    gifts.forEach(function(g){
      var from=parseInt(g.dataset.from,10)||1;
      var un=TIER>=from;
      g.classList.toggle('on',un);g.classList.toggle('lk',!un);
      var ic=g.querySelector('.mirb-gi');
      if(ic&&!ic.querySelector('img'))ic.textContent=un?g.dataset.icon:'🔒';
      var ne=g.querySelector('.mirb-gn');
      if(ne)ne.textContent=un?g.dataset.name:(g.dataset.lock||'Por desbloquear');
    });
    syncForms(c.dataset.v);
  }

  function giftVariants(){
    var out=[];
    gifts.forEach(function(g){
      var from=parseInt(g.dataset.from,10)||1;
      var vid=(g.dataset.vid||'').trim();
      if(vid && vid!=='0' && TIER>=from && out.indexOf(vid)<0) out.push(vid);
    });
    return out;
  }

  cards.forEach(function(c){c.addEventListener('click',function(){pick(c);});});

  gifts.forEach(function(g){
    g.setAttribute('role','button');
    g.setAttribute('tabindex','0');
    function go(){
      var from=parseInt(g.dataset.from,10)||1;
      var t=cards[from-1];
      if(t)pick(t);
    }
    g.addEventListener('click',go);
    g.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){e.preventDefault();go();}});
  });

  // On n'ajoute JAMAIS le pack nous-memes : Horizon s'en charge et rafraichit le
  // tiroir proprement. On se contente de forcer la bonne variante dans le
  // formulaire, de glisser les cadeaux dans le panier, puis de rejouer le clic.
  document.addEventListener('click',function(e){
    if(LETTHROUGH)return;
    var t=e.target;
    if(!t||!t.closest)return;
    var btn=t.closest('[name="add"], .add-to-cart-button, .sticky-add-to-cart__button');
    if(!btn||!CURRENT||BUSY)return;

    // garantie : la variante du palier affiche est bien celle qui part au panier
    syncForms(CURRENT);

    var wanted=giftVariants();
    if(!wanted.length)return; // aucun cadeau a joindre : comportement natif

    e.preventDefault();
    e.stopImmediatePropagation();
    BUSY=true;

    function replay(){
      BUSY=false;
      LETTHROUGH=true;
      syncForms(CURRENT);
      try{ btn.click(); }catch(err){}
      setTimeout(function(){LETTHROUGH=false;},0);
    }

    fetch('/cart.js',{headers:{'Accept':'application/json'}})
      .then(function(r){return r.json();})
      .then(function(cart){
        var have={};
        (cart.items||[]).forEach(function(i){have[String(i.variant_id)]=true;});
        var items=[];
        wanted.forEach(function(v){ if(!have[String(v)]) items.push({id:Number(v),quantity:1}); });
        if(!items.length) return null;
        return fetch('/cart/add.js',{
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({items:items})
        });
      })
      .then(function(){ replay(); })
      .catch(function(err){ console.warn('[mirenae] cadeaux non ajoutes',err); replay(); });
  },true);

  var n=0,iv=setInterval(function(){
    n++;
    hideNative();
    syncForms(CURRENT);
    if(n>20)clearInterval(iv);
  },300);
  pick(W.querySelector('.mirb-card.on')||cards[cards.length-1]);
  syncForms(CURRENT);
  document.addEventListener('DOMContentLoaded',function(){syncForms(CURRENT);});
})();
